<template>
    <div>
        <div>
            <b-form @submit="onSubmit"
                v-if="show">
                <div class="my-5">
                    <b-form-input type="password"
                        :placeholder="$t('users.new-password')"
                        id="inputPassword"
                        required
                        class="inputField"
                        v-model="form.password"
                        :state="!$v.form.password.$dirty && !$v.form.password.$invalid && $v.form.password.$minLength"
                        aria-describedby="input-live-feedback"></b-form-input>
                    <!-- This will only be shown if the preceding input has an invalid state -->
                    <b-form-invalid-feedback id="input-live-feedback">
                        {{ $t('validations.min-length',{num: $v.form.password.$params.minLength.min}) }}
                    </b-form-invalid-feedback>
                </div>
                <b-button pill
                    class="formButton"
                    type="submit"
                    :disabled="$v.$invalid">
                    {{ $t('actions.reset') }}
                </b-button>
            </b-form>
        </div>
        <div class="my-3">
            <a href="/"
                class="lostPassword">
                {{ $t('general.home') }}
            </a>
        </div>
        <b-alert v-model="errored"
            variant="danger"
            dismissible>
            {{ errorMsg }}
        </b-alert>
    </div>
</template>

<script>
import usersService from '@/services/users/'
import { required, minLength } from 'vuelidate/lib/validators'
import Swal from 'sweetalert2'

export default {
    name: 'Resetform',
    data () {
        return {
            form: {
                password: ''
            },
            show: true,
            errorMsg: '',
            errored: false
        }
    },
    validations: {
        form: {
            password: {
                required,
                minLength: minLength(8)
            }
        }
    },
    methods: {
        resetSuccess () {
            Swal.fire({
                title: this.$t('users.reset-password'),
                text: this.$t('validations.operation-performed-successfully'),
                type: 'success',
                showCloseButton: true,
                showCancelButton: false,
                confirmButtonText: this.$t('actions.ok')
            }).then((result) => {
                if (result.value) {
                    this.$router.push('/login')
                }
            })
        },

        async onSubmit (evt) {
            evt.preventDefault()

            let self = this
            let parameters = {
                password: self.form.password,
                user_id: self.$route.params.userid,
                token: self.$route.params.token
            }

            let response = await usersService.reset(parameters)

            if (response.data.user_id) {
                self.resetSuccess()
            }
        }
    }
}
</script>
